import { useEffect, useState } from "react";
import SpecialistApi from "../../../api/specialistsApi";
import CircleAvatar from "../../../components/CircleAvatar/CircleAvatar";
import { TypeUserData } from "../../../types/TypeUsers";
import { getDurationString } from "../../../utils/dateActions";
import { getTranslation } from "../../../utils/getTranslation";
import s from "./WebinarTeam.module.css";

type WebinarTeamProps = {
  searchType: "coSpeakerUser" | "admin";
  userId: string;
};

const WebinarTeam = ({ searchType, userId }: WebinarTeamProps) => {
  const token = localStorage.getItem("token");
  const [user, setUser] = useState<TypeUserData | undefined>();

  useEffect(() => {
    if (!token) return;
    (async () => {
      const payload = {
        filters: {
          shortId: userId,
          page: 1,
          limit: 1,
        },
      };

      const response = await SpecialistApi.getFilteredSpecialists(
        token,
        payload,
      );

      if (response.status && response.users && response.users.length) {
        setUser(response.users[0]);
      } else {
        setUser(undefined);
      }
    })();
  }, [userId]);

  return (
    <div className={s.container}>
      {user ? (
        <div className={s.userCard}>
          <CircleAvatar
            userId={user._id}
            width="130px"
            height="130px"
            borderRadius="20px"
          />
          <div className={s.userInfo}>
            <div className={s.nameTitle}>
              <span>
                {getTranslation(
                  user.name,

                  "en",
                )}{" "}
                {getTranslation(
                  user.surname,

                  "en",
                )}
              </span>
            </div>

            <div className={s.mainSpecBlock}>
              {user?.specialistIds &&
                user.specialistIds.map((item, index) => (
                  <div key={index}>
                    <span className={s.specialityTitle}>
                      {item.level && getTranslation(item.level.title, "en")}{" "}
                      {item.mainSpecializations[0].specialization.toLowerCase()}
                    </span>{" "}
                    {item.practiceStartYear && "- " + item.practiceStartYear
                      ? getDurationString(
                          new Date(item.practiceStartYear),
                          new Date(),
                          "en",
                        ).text
                      : " - "}
                  </div>
                ))}
            </div>

            {user.briefDescription && (
              <div className={s.briefDescription}>
                {getTranslation(user.briefDescription, "en")}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className={s.emptyUser}></div>
      )}
    </div>
  );
};

export default WebinarTeam;
